import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';

import Login from './pages/Login';
import SetupAccount from './pages/SetupAccount';
import AcceptTerms from './pages/AcceptTerms';
import TargetList from './pages/TargetList';
import TargetDetails from './pages/TargetDetails';
import Profile from './pages/Profile';
import MyProposals from './pages/MyProposals';
import PublicProposals from './pages/PublicProposals';
import NewProposal from './pages/NewProposal';
import AdminPanel from './pages/admin/AdminPanel';
import ManageUsers from './pages/admin/ManageUsers';
import ManageTargets from './pages/admin/ManageTargets';
import Goals from './pages/Goals';

import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="app">
          <Navbar />
          <main className="main-content">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/setup/:token" element={<SetupAccount />} />
              <Route path="/accept-terms" element={<AcceptTerms />} />

              <Route path="/targets" element={
                <PrivateRoute><TargetList /></PrivateRoute>
              } />
              <Route path="/targets/:id" element={
                <PrivateRoute><TargetDetails /></PrivateRoute>
              } />
              <Route path="/profile" element={
                <PrivateRoute><Profile /></PrivateRoute>
              } />
              <Route path="/proposals/my" element={
                <PrivateRoute><MyProposals /></PrivateRoute>
              } />
              <Route path="/proposals/public" element={
                <PrivateRoute><PublicProposals /></PrivateRoute>
              } />
              <Route path="/proposals/new" element={
                <PrivateRoute><NewProposal /></PrivateRoute>
              } />
              <Route path="/goals" element={
                <PrivateRoute><Goals /></PrivateRoute>
              } />

              <Route path="/admin" element={
                <AdminRoute><AdminPanel /></AdminRoute>
              } />
              <Route path="/admin/users" element={
                <AdminRoute><ManageUsers /></AdminRoute>
              } />
              <Route path="/admin/targets" element={
                <AdminRoute><ManageTargets /></AdminRoute>
              } />

              <Route path="/" element={<Navigate to="/targets" replace />} />
              <Route path="*" element={<Navigate to="/targets" replace />} />
            </Routes>
          </main>
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
